<template>
    <div>
        <div class="card mt-5">
          <KTCodePreview>
            <template v-slot:body>
              <b-tabs>
                <b-tab title="Daftar Approval" active>
                  <DaftarBerkas @refreshTabs="refreshAllTabs" />
                </b-tab>
                <b-tab title="Disetujui">
                  <DaftarDisetujui :refreshEvent="refreshEvent" />
                </b-tab>
                <b-tab title="Ditolak">
                  <DaftarDitolak :refreshEvent="refreshEvent" />
                </b-tab>
              </b-tabs>
            </template>
          </KTCodePreview>
        </div>
    </div>
  </template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import KTCodePreview from "@/view/content/CardContent.vue";
import DaftarBerkas from "@/view/pages/mahasiswa/verifikasiberkas/Daftar.vue";
import DaftarDisetujui from "@/view/pages/mahasiswa/verifikasiberkas/Disetujui.vue";
import DaftarDitolak from "@/view/pages/mahasiswa/verifikasiberkas/Ditolak.vue";

export default {
  name: 'listPengaduan',
  components: {
    KTCodePreview,
    DaftarBerkas,
    DaftarDisetujui,
    DaftarDitolak
  },
  data() {
    return {
      tabs: '',
      refreshEvent: false
    }
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Verifikasi Berkas" },
    ]);
    this.activetabs();
    localStorage.removeItem('tabs');
  },
  methods: {
    activetabs() {
      this.tabs = localStorage.getItem('tabs');
    },
    refreshAllTabs() {
      // Ubah nilai refreshEvent untuk memicu ulang fetchData pada child components
      this.refreshEvent = !this.refreshEvent;
      
    },
  },
}
</script>

<style scoped>
    .text-green {
        color: #006B8C;
    }

    .background-color-green{
        background-color: #006B8C !important;
    }

    .white-color{
        color: white !important;
    }
</style>